<script lang="ts">
  import { Col, Container, Row } from "sveltestrap";
  import ForgotPasswordForm from "./ForgotPasswordForm.svelte";
</script>
<section>         
    <Container fluid class="p-0"> 
        <Row class="m-0">
          <Col xs="12" class="p-0">  
            <div class="login-card">              
                <div class="login-main">
                    <ForgotPasswordForm /> 
                </div>
            </div>
          </Col>
       </Row>
    </Container>
</section>